import { useQuery } from '@tanstack/react-query';
import { getQuoteById } from '../api/documents';

export function useDocument(id: string | null) {
  return useQuery({
    queryKey: ['documents', id],
    queryFn: () => getQuoteById(id!),
    enabled: !!id,
  });
}
